export default "__VITE_ASSET__DqLO_3mz__"